export const capitalize = (str: string | null | undefined): string => {
	if (str == null) return ''; // Handles both null and undefined
	return str.charAt(0).toUpperCase() + str.slice(1);
};